//@flow
import { riderMasterContainerFactory } from 'common/entity/riderMaster/RiderMasterContainer';
import PjpActions from 'common/redux/actions/pjpMaster';
import RiderSelectors from 'common/redux/selectors/rider';
import nestedEntityDialogFactory from 'common/entity/pjpMaster/NestedEntityDialog';
import PjpSelectors from 'common/redux/selectors/pjpMaster';

const RiderMasterDialog = nestedEntityDialogFactory({
    fetchEntities: PjpActions.fetchPjpRiders,
    containerFactory: riderMasterContainerFactory,
    getFilteredEntitesCount: RiderSelectors.getFilteredEntitesCount,
    getTotalEntitiesCount: PjpSelectors.getTotalRidersCount
});

export { RiderMasterDialog };
export default RiderMasterDialog;
